import { ButtonNew as Button, ColorOptions } from '@jfs/ui-new'
import { useStores } from '../../../data/store'

interface ActionButtonProps {
  title: string
  onPress: () => void
  disabled?: boolean
  isLoading?: boolean
}
export const ActionButton = ({ title, onPress, disabled, isLoading }: ActionButtonProps) => {
  const { theme } = useStores((root) => ({
    theme: root.config.merchantTheme,
  }))
  return (
    <Button
      onPress={onPress}
      title={title}
      width={'100%'}
      type="primaryFullWidth"
      height={48}
      borderRadius={8}
      disabled={disabled}
      isLoading={isLoading}
      color={theme?.brandColor as ColorOptions}
      titleColor={theme?.headingText as ColorOptions}
      hoverColor={theme?.brandColor as ColorOptions}
      underlayColor={theme?.brandColor as ColorOptions}
      loadingColor={theme?.headingText as ColorOptions}
      testID="action-btn"
    />
  )
}
